import React from 'react';
import { Form } from 'react-bootstrap';
import styles from './styles.module.scss';

interface DateRangeFilterProps {
  selectedRange: string;
  onChange: (range: string) => void;
}

const DATE_RANGES = [
  { value: 'all', label: 'All Dates' },
  { value: 'week', label: 'Next 7 Days' },
  { value: 'month', label: 'Next 30 Days' },
  { value: 'quarter', label: 'Next 90 Days' },
];

export const DateRangeFilter: React.FC<DateRangeFilterProps> = ({ selectedRange, onChange }) => {
  return (
    <div className={styles.filterSection}>
      {DATE_RANGES.map(({ value, label }) => (
        <Form.Check
          key={value}
          type="radio"
          id={`date-range-${value}`}
          label={label}
          name="dateRange"
          checked={selectedRange === value}
          onChange={() => onChange(value)}
          className={styles.filterRadio}
        />
      ))}
    </div>
  );
};